export const datePickerConstants = [
  {
    Today: {
      from: new Date(),
      to: new Date(),
    },
  },
  {
    "Last Week": {
      from: new Date(new Date().setDate(new Date().getDate() - 7)),
      to: new Date(),
    },
  },
  {
    "Last Month": {
      from: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      to: new Date(),
    },
  },
  {
    "Last Quarter": {
      from: new Date(new Date().setMonth(new Date().getMonth() - 3)),
      to: new Date(),
    },
  },
  {
    "Last Year": {
      from: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
      to: new Date(),
    },
  },

  { "Custom Range": { from: null, to: null } },
];
